import classNames from 'classnames';
import type { FC } from 'react';

interface Props {
  className?: string;
  onClose: () => void;
  label: string;
}

export const SlidePaneClose: FC<Props> = (props) => (
  <div className={classNames('slide-pane__close', props.className)}>
    <button onClick={props.onClose} type='button'>
      <i className='fa fa-chevron-left' />
      {props.label}
    </button>
  </div>
);
